module.exports = __webpack_public_path__ + "media/images/ic-videos-34920ec075e158e7931c6b35ad836a4d.svg";